// extracted by mini-css-extract-plugin
export default {"container":"side-menu-right-container_container__g0IXf"};